<template>
  <v-container class="px-8 py-5">
    <v-row class="body-2 font-weight-light justify-space-between">
      <div>
        <v-breadcrumbs class="breadcrumbs pa-0" :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <span>{{$todayDate()}}</span>
    </v-row>
    <v-form ref="form">
      <v-row class="justify-center pt-6">
        <v-col cols="12" sm="7">
          <v-row>
            <v-col cols="12" class="pa-0">
              <v-card
                outlined
                class="pa-4"
              >
                <v-row>
                  <v-col cols="4">
                    <v-subheader class="justify-end">Naziv nastavnog plana: </v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      outlined
                      hide-details
                      height="44"
                      dense
                      v-model="schoolPlanName"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-subheader class="justify-end">Razred: </v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                      :items="classes"
                      item-value="id"
                      item-text="text"
                      placeholder="Odaberite razred"
                      hide-details
                      v-model="selectedClass"
                      outlined
                      height="44"
                      dense
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="selectedClass">
                  <v-col cols="4">
                    <v-subheader class="justify-end">Smjer: </v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-treeview
                      v-if="educationalFields"
                      :items="filteredEduFields"
                      item-text="name"
                      item-value="id"
                      open-on-click
                      selection-type="independent"
                      ref="treeview"
                    >
                      <template slot="prepend" slot-scope="props">
                        <v-checkbox
                          dense
                          hide-details
                          v-if="!props.item.children"
                          v-model="props.item.selected"
                          @click="setSelected(props.item)"
                        >
                        </v-checkbox>
                      </template>
                    </v-treeview>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-subheader class="justify-end">Škola: </v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                      :items="schools"
                      placeholder="Odaberite školu"
                      hide-details
                      item-text="name"
                      item-value="id"
                      v-model="selectedSchool"
                      outlined
                      height="44"
                      dense
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="3">
          <v-btn block height="44" class="primary elevation-0 mb-4" @click="createSchoolPlan">Potvrdi</v-btn>
          <v-btn block height="44" outlined class="elevation-0" @click="$router.push('/admin/nastavni_planovi')">Odustani</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import {serverBus} from "../../main";
import ApiV2 from '../../services/ApiV2'

export default {
  components: {
  },
  data: () => ({
    checkbox: false,
    schoolPlanName: '',
    selectedClass: null,
    selectedSchool: null,
    selectedFields: [],
    educationalFields: [],
    schools: []
  }),
  computed: {
    classes() {
      let classNames = [{header: 'Osnovna škola'}]
      for(let i = 1; i <= 14; i++){
        if(i > 10) {
          classNames.push({id: i.toString(), text: `${i % 10}. razred - Srednja škola`})
        } else if(i !== 10) {
          classNames.push({id: i.toString(), text: `${i}. razred`});
        } else {
          classNames.push({divider: true})
          classNames.push({header: "Srednja škola"})
        }
      }
      return classNames;
    },

    breadcrumbs() {
      return [
        {
          text: 'Nastavni planovi',
          disabled: false,
          exact: true,
          to: '/admin/nastavni_planovi',
        },
        {
          text: 'Dodaj novi nastavni plan',
          disabled: true
        },
      ]
    },

    filteredEduFields(){
      let data = this.educationalFields;

      if(+this.selectedClass < 10){
        return data.slice(0, 1);
      } else {
        return data.slice(1, 2);
      }
    }, 
  },
  methods: {
    setSelected(item) {
      const index = this.selectedFields.indexOf(item.id);
      if (index > -1) {
        this.selectedFields.splice(index, 1);
      }

      if(item.selected){
        this.selectedFields.push(item.id);
      }
    },

    getEducationalFields() {
      ApiV2.get('educational_fields', {
        params: {
          "filter[parent_id]": "n=",
          with: "children"
        }
      }).then(response => {
          this.educationalFields = response.data.data;
        });
    },

    getSchools(){
      ApiV2.get('schools', {
        params: {
          perPage: -1
        }
      }).then(response => {
          this.schools = response.data.data;
          this.schools.unshift({name: 'Sve škole', id: null})
        })
        .catch(error => {
          console.log(error);
        })
    },
    createSchoolPlan() {
      ApiV2.post('school_plans', {
        title: this.schoolPlanName,
        school_class: this.selectedClass,
        canton_id: parseInt(localStorage.getItem('organisation_id')),
        school_id: this.selectedSchool,
        school_year_id: parseInt(localStorage.getItem('school_year_id')),
        relations: {
            educationalFields: {
                data: this.selectedFields,
                method: "attach"
            }
        }
    }).then((response) => {
        this.$router.push(`/admin/nastavni_planovi/${response.data.id}`)
        serverBus.$emit('show-snackbar', true, "Uspješno ste dodali novi nastavni plan.");
      })
      .catch((error) => {
        if (error.response.status == 422) {
          let msg = ''
          for (let key in error.response.data.errors) {
            msg += `${error.response.data.errors[key][0]}; `
          }
          serverBus.$emit('show-snackbar', false, msg)
        } else {
          serverBus.$emit('show-snackbar', false);
        }
      });
    }
  },
  created() {
    this.getEducationalFields();
    this.getSchools();
  }
};
</script>

<style>
  .v-treeview-node__prepend {
    min-width: initial;
  }
</style>